export default "__VITE_ASSET__D3niXp6j__"